import { Component, OnInit } from '@angular/core';
import { PageLoaderService } from '../../ui-components/page-loader/page-loader.service';

@Component({
  selector: 'app-restricted-user',
  templateUrl: './restricted-user.component.html',
  styleUrls: ['./error.component.scss']
})
export class RestrictedUserComponent implements OnInit {

  constructor(
    private pageloaderService: PageLoaderService) { }

  ngOnInit() {
    this.pageloaderService.setPageLoaderStatus(true);
  }

}
